import React from 'react';
import ProgressiveCheckoutLayout from 'hellospa/components/sign-progressive-checkout/layout';
import ProgressiveCheckoutPlanInfo from 'hellospa/components/sign-progressive-checkout/progressive-checkout-plan-info';
import { logPAPEvent } from 'js/sign-components/common/product-analytics-pipeline';
import { PAP_View_SignPage } from '@dropbox/pap-events/sign_standalone/view_sign_page';
import SignInForm from './sign-in-form';

function ProgressiveCheckoutSignInPage() {
  React.useEffect(() => {
    logPAPEvent(
      PAP_View_SignPage({
        signPage: 'sign_in',
        signSiso: 'progressive',
      }),
    );
  }, []);

  return (
    <ProgressiveCheckoutLayout
      dataTestId="progressive-checkout-sign-in-page"
      screenLeftSide={<SignInForm />}
      screenRightSide={<ProgressiveCheckoutPlanInfo />}
    />
  );
}

export default ProgressiveCheckoutSignInPage;
